//Componente Front-end
import { Modal, ButtonToolbar, Button, Icon } from 'rsuite';
import React from 'react';
import Card from './Card';
import ButtonTip from './ButtonTip';
export default class Dicas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      tipsOpen: Array(this.props.palavras.length).fill(false).fill(true, 0, 1)
    };
    console.log(props)
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }
  close() {
    this.setState({ show: false });
  }
  open() {
    console.log(this.state.show)
    this.setState({ show: true });
  }

  renderDica(Dica, help, index) {
    return <Card
      key={index + 1000 }
      dica={Dica}
      ajuda={help}
      ind={index + 500}
      palavra={this.props.palavrasCertas[index]}
      onClick={() => { this.props.onClick() }}
      tips={this.props.tips}
      tipsOpen={this.state.tipsOpen}
      palavras={this.props.palavras}
    />;
  }


  renderDicas() {

    var dicas = [];
    for (let index = 0; index < this.props.dicas['dicas'].length; index++) {
      dicas.push(this.renderDica(this.props.dicas['dicas'][index], this.props.dicas['ajuda'][index], index));
    }
    this.versao+=1;
    return React.createElement('div', { className: "col display fullWidth" }, dicas);
  }

  updateTips(tip) {
    var temp = this.state.tipsOpen
    for (let index = 0; index < this.props.palavras.length; index++) {
      temp[index] = false;
    }
    temp[tip] = true;
    this.setState({ tipsOpen: temp });
    console.log(this.state.tipsOpen);
    console.log(tip);
  }

  renderButtonTip(ind) {
    return <ButtonTip key={ind + 600} tipsOpen={this.state.tipsOpen} ind={ind} palavras={this.props.palavras} updateTips={() => this.updateTips(ind)} />
  }

  renderButtons() {
    var paresbuttons = []
    var buttonsdicas = []
    for (let index = 0; index < this.props.palavras.length; index++) {
      buttonsdicas.push(this.renderButtonTip(index));
      // if(index%2 === 1 && index !== 0){
      //   paresbuttons.push(React.createElement('div', { className: "col buttonsTips" }, buttonsdicas));
      //   buttonsdicas = []
      // }
      // ALternativa ATENÇÃO AMPLIAR NECESSIDADES com módulos adjacentes
      if(this.props.palavras.length%5 === 0 )
        paresbuttons.push(React.createElement('div', { className: "col width5 buttonsTips" }, buttonsdicas));
      else if(this.props.palavras.length%4 === 0 )
        paresbuttons.push(React.createElement('div', { className: "col width4 buttonsTips" }, buttonsdicas));
      else if(this.props.palavras.length%3 === 0 )
        paresbuttons.push(React.createElement('div', { className: "col width3 buttonsTips" }, buttonsdicas));
      else if(this.props.palavras.length%2 === 0 )
        paresbuttons.push(React.createElement('div', { className: "col width2 buttonsTips" }, buttonsdicas));
      buttonsdicas = []
      
    }
    return React.createElement('div', { className: "row disposicao-dicas" }, paresbuttons);
  }


  render() {
    var mostrar = {
        'display': 'block'
    };

    var esconder = {
        'display': 'none'
    };
    return (
      <div className="modal-container center">
        <ButtonToolbar id="buttonDica"  className='modal-dicas-sm'>
          <Button className='sizeButton borColor3 Color2 button1 buttonR'><Icon icon='lightbulb-o' onClick={this.open} size="2x" /></Button>
        </ButtonToolbar>
        <div className='modal-dicas'>
          <div className='row center'>
            {this.renderButtons()}
          </div>          
          {this.renderDicas()}        
          
        </div>

        
          <div className="modal-personalizado"
            style={this.state.show? mostrar : esconder }
          
          >
            <div className="modal-body bkColor1 opacidade" style={{padding:'2em'}}>
              <div className="col">
              <div className='row center'>
              {this.renderButtons()}
            </div>
            <div className='row center margin-top'>
            {this.renderDicas()}
            </div>
            
              </div>
          
            <Button className='modal-fechar' onClick={this.close} appearance="link">
            <h6 className='iconShare Color4'><Icon className='iconShare Color4' icon='back-arrow' size='1x'/> VOLTAR</h6>

            </Button>
            </div>
          </div>
      </div>

    );
  }
}